import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import PartnersShiftedUi from 'hb-builder/components/UIComponents/page/block/Partners/PartnersShiftedUI/PartnersShiftedUI';
import { useRendererContext } from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { PartnersItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';

const PartnersShifted: RenderComponent = () => <div />; // never used

interface PartnersShiftedItem
  extends Omit<DocumentItem<PartnersItemAttributes>, 'children'> {
  children: PartnersShiftedItem[];
  index?: number;
  partnerImageAlt?: '';
  partnerImageUrl: string;
  partnersCount: number;
}

const Render = ({ item }: RenderProps<PartnersShiftedItem>) => {
  const { subdomainNetworkUrl } = useRendererContext();

  return (
    <PartnersShiftedUi
      item={item}
      subdomainNetworkUrl={subdomainNetworkUrl}
      withImageSetter={false}
    />
  );
};

PartnersShifted.componentName = 'PartnersShifted';
PartnersShifted.Render = Render;

export default PartnersShifted;
